<template>
    <a-card>
    <h3 style="text-align: center;margin:20px 0 40px">项目经费预算</h3>
            <!--可编辑区域 start-->
            <a-row :gutter="[24,8]">
                <a-col :span="24"><h4>经费来源预算</h4></a-col>
                <a-col :span="24">
                    <span class="showIf"  style="margin-bottom:10px;display:block" v-for="(item,key) in rootIn" :key="key">
                        {{ key+1 }}、{{ item.costName }}: <a-input-number disabled v-model:value="rootIn[key].cost"/>
                        <span  style="margin-left:20px;" v-if="rootIn[key].childrenFund[0]">其中：</span>
                        <span style="display:inline-block;margin-left:20px" v-for="(items,keys) in rootIn[key].childrenFund" :key="keys">
                            {{ items.costName }}: <a-input-number disabled v-model:value="rootIn[key].childrenFund[keys].cost"/>
                        </span>
                        <br>
                    </span>
                </a-col>
                
                <a-col :span="24"><h4>经费支出预算</h4></a-col>
                <a-col :span="24">
                    <span  class="showIf" style="margin-bottom:10px;display:block" v-for="(item,key) in payOut" :key="key">
                        {{ key+1 }}、{{ item.costName }}: <a-input-number disabled v-model:value="payOut[key].cost"/>
                        <span  style="margin-left:20px;" v-if="payOut[key].childrenFund[0]">其中：</span>
                        <span style="display:inline-block;margin-right:20px" v-for="(items,keys) in payOut[key].childrenFund" :key="keys">
                            {{ items.costName }}: <a-input-number disabled v-model:value="payOut[key].childrenFund[keys].cost"/>
                        </span>
                        <br>
                    </span>
                </a-col>
            </a-row>
    </a-card>
</template>

<script>

    import { projectFundRecord } from "@/api/TechnologieprojekteApply";
    import {
        formMixin
    } from "@/mixins";
    export default {
        name: "项目经费预算",
        mixins: [formMixin],
        components: {
        },
        data() {
            return {
                rootIn:null, //来源
                payOut:null, //支出
                options: null,
                form:{
                },
            }
        },

        mounted() {
            this.getData()
        },
        methods: {
            getData(){
                this.getAction({
                    url: projectFundRecord.fundDetail,
                    params: { 
                        projectId: this.$route.query.projectId,
                     }
                }).then((res) => {
                    this.rootIn = res[0]
                    this.payOut = res[1]
                });
            }
        }

    }
</script>
